import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Field } from '@sb-tools/typescript/models/field.model';
import { ClientField } from './../../../common/models/client-field.model';
import { FormService } from './../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { NumberToArrayPipe } from '@sb-tools/typescript/pipes/number-to-array.pipe';
import { InlineSVGComponent } from '../../../../Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'sb-star-rating',
    templateUrl: './star-rating.component.html',
    styleUrls: ['./star-rating.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NumberToArrayPipe, InlineSVGComponent, FormsModule],
})
export class StarRatingComponent {
    @Input() formField: Field | ClientField;

    constructor(
        public formService: FormService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {}

    updateStarCount(value: number): void {
        this.formField.value = value;
        this.changeDetectorRef.detectChanges();
    }
}
